import { Api } from 'models/services/api';
import { UpdateStoreQuery } from 'models/services/graphql';

import { StoreData, StoreDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: StoreDataToSave;
};

const RequestQuery = `
  mutation UpdateStore($id: ID!, $input: StoreInput!) {
    ${UpdateStoreQuery}
  }
`;

type ResponseData = {
  data: {
    updateStore: StoreData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: StoreData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateStore;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };